import { type ReactNode } from "react";
import { Label, TagGroup, TagList } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { HoverInfo } from "../basic/Tooltip";
import { Flex } from "../../../../styled-system/jsx";
import { css } from "../../../../styled-system/css";
import { formField, type FormFieldVariant } from "../../../../styled-system/recipes";
import Tag from "../basic/Tag";

const TagsReviewDisplay = ({
  tags,
  label,
  toolTip,
  variant,
  readOnly = true,
  onRemove,
}: {
  tags: string[] | null;
  label?: ReactNode;
  toolTip?: string;
  variant?: FormFieldVariant["variant"];
  readOnly?: boolean;
  onRemove?: (tag: string) => void;
}) => {
  const { t } = useTranslation(["common"]);
  const classes = formField({ variant });

  if (!tags || tags.length < 1) return null;

  return (
    <div>
      <Flex gap={"small"}>
        <Label className={classes.label}>{label}</Label>
        {toolTip && <HoverInfo iconCss={{ color: "grey", fontSize: "small" }}>{toolTip}</HoverInfo>}
      </Flex>
      <TagGroup aria-label={t(($) => $.common.tagsReview["Selected tags"])}>
        <TagList
          items={tags.map((tag) => ({ id: tag, label: tag }))}
          className={css({
            display: "flex",
            gap: "small",
            maxHeight: "110px",
            marginBottom: "small",
            paddingRight: "small",
            overflowY: "auto",
            flexWrap: "wrap",
          })}
        >
          {(tag) => <Tag tag={tag} onRemove={onRemove} isDisabled={readOnly} />}
        </TagList>
      </TagGroup>
    </div>
  );
};

export default TagsReviewDisplay;
